module.exports = __webpack_public_path__ + "img/u2209.333310ad.svg";